/**
 * @generated SignedSource<<9c557730432e7b0ffe4832faaf12344e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type IntegrationImportProjectsTable_ext_project$data = ReadonlyArray<{
  readonly id: number;
  readonly name: string;
  readonly remote_id: string | null | undefined;
  readonly remote_key: string | null | undefined;
  readonly sync: boolean;
  readonly " $fragmentType": "IntegrationImportProjectsTable_ext_project";
}>;
export type IntegrationImportProjectsTable_ext_project$key = ReadonlyArray<{
  readonly " $data"?: IntegrationImportProjectsTable_ext_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"IntegrationImportProjectsTable_ext_project">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "IntegrationImportProjectsTable_ext_project",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sync",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "remote_id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "remote_key",
      "storageKey": null
    }
  ],
  "type": "ext_project",
  "abstractKey": null
};

(node as any).hash = "79c92063b1afa85cf4f25bbbc20f4c9c";

export default node;
